import React, { useState } from 'react';

import styles from './CreditsManipulator.module.css';
import {
  creditsChangeType,
  licenceTypes
} from '../../../../../helpers/constants';

import {
  eurosToCredits,
  creditsToEuros,
  addSpaces,
  removeNonNumeric
} from '../../../../../helpers/creditsConversion/creditsConversion';

export default ({
  level,
  internalRecord,
  setInternalRecord,
  activePopup,
  parentWithLicence,
  isEditing,
  showAdditionalBudget
}) => {
  const [creditsChangeTypePopup, setCreditsChangeTypePopup] = useState(
    creditsChangeType.INCREASE
  );
  const [creditsChangeValue, setCreditsChangeValue] = useState(0);
  const [transactionExplanation, setTransactionExplanation] = useState('');
  const [initialLicence] = useState(
    internalRecord && internalRecord.licence ? internalRecord.licence : null
  );

  const isForbiddenToSaveCredits =
    creditsChangeTypePopup === creditsChangeType.DECREASE &&
    creditsChangeValue > internalRecord.creditsLeft;

  const isLevelTwo = level === 2;
  const isLevelOneEditingCurrentLicence =
    level === 1 &&
    isEditing &&
    initialLicence &&
    internalRecord &&
    internalRecord.licence &&
    internalRecord.licence === initialLicence;

  const showLicenceExplanationField =
    isLevelTwo || isLevelOneEditingCurrentLicence;

  const transactionExplanationProvided =
    transactionExplanation &&
    transactionExplanation.length &&
    transactionExplanation.trim() !== '';

  const notAllowedToSaveChanges =
    isForbiddenToSaveCredits ||
    !creditsChangeValue ||
    (showLicenceExplanationField && !transactionExplanationProvided);

  const resetCreditsFields = () => {
    setCreditsChangeValue(0);
    setTransactionExplanation('');
  };

  const onCreditsChangeTypeSave = () => {
    if (!notAllowedToSaveChanges) {
      const creditsChangeNotRounded =
        creditsChangeTypePopup === creditsChangeType.INCREASE
          ? creditsChangeValue
          : -1 * creditsChangeValue;
      const creditsChange = Math.round(creditsChangeNotRounded * 1000) / 1000;

      const newInternalRecord = {
        ...internalRecord
      };

      const previousCreditsLeft = newInternalRecord.creditsLeft;
      const newCreditsLeft =
        Math.round(
          ((newInternalRecord.creditsLeft || 0) + creditsChange) * 1000
        ) / 1000;
      newInternalRecord.creditsLeft = newCreditsLeft;
      let globalCreditsChange = creditsChangeType.NO_CHANGE;
      if (
        activePopup &&
        activePopup.record &&
        activePopup.record.creditsLeft > newInternalRecord.creditsLeft
      )
        globalCreditsChange = creditsChangeType.DECREASE;
      if (
        activePopup &&
        activePopup.record &&
        activePopup.record.creditsLeft < newInternalRecord.creditsLeft
      )
        globalCreditsChange = creditsChangeType.INCREASE;

      newInternalRecord.creditsChange = globalCreditsChange;
      newInternalRecord.creditsChangeAmount = Math.abs(
        (activePopup && activePopup.record && activePopup.record.creditsLeft
          ? activePopup.record.creditsLeft
          : 0) - (newInternalRecord.creditsLeft || 0)
      );

      if (level === 1) {
        if (
          globalCreditsChange === creditsChangeType.INCREASE ||
          globalCreditsChange === creditsChangeType.NO_CHANGE
        ) {
          const newCreditsAllocated =
            Math.round(
              (newInternalRecord.creditsAllocated + creditsChange) * 1000
            ) / 1000;
          newInternalRecord.creditsAllocated = newCreditsAllocated;
        }
      }

      if (level === 2) {
        const newCreditsAllocated =
          Math.round(
            (newInternalRecord.creditsAllocated + creditsChange) * 1000
          ) / 1000;
        newInternalRecord.creditsAllocated = newCreditsAllocated;
      }

      // Multiple credits changes with explanations are saved in Credits transactions array
      if (showLicenceExplanationField) {
        const newCreditsTransaction = {
          creditsChange: creditsChangeType.NO_CHANGE,
          creditsChangeAmount: 0,
          transactionExplanation: ''
        };

        if (previousCreditsLeft > newCreditsLeft)
          newCreditsTransaction.creditsChange = creditsChangeType.DECREASE;
        if (previousCreditsLeft < newCreditsLeft)
          newCreditsTransaction.creditsChange = creditsChangeType.INCREASE;

        const creditsChangeAmountBetweenPreviousAndCurrent = Math.abs(
          (previousCreditsLeft || 0) - (newCreditsLeft || 0)
        );

        newCreditsTransaction.creditsChangeAmount = creditsChangeAmountBetweenPreviousAndCurrent;

        if (showLicenceExplanationField && transactionExplanationProvided) {
          newCreditsTransaction.transactionExplanation = transactionExplanation;
        }

        newInternalRecord.creditsTransactions =
          newInternalRecord.creditsTransactions &&
          newInternalRecord.creditsTransactions.length
            ? [...newInternalRecord.creditsTransactions, newCreditsTransaction]
            : [newCreditsTransaction];
      }

      setInternalRecord(newInternalRecord);
      resetCreditsFields();
    }
  };

  if (
    (level === 1 &&
      internalRecord &&
      internalRecord.licence &&
      !(internalRecord.licence === licenceTypes.UNLIMITED && !isEditing)) ||
    (level === 2 &&
      parentWithLicence &&
      (internalRecord && internalRecord.creditsAllocated !== null) &&
      internalRecord.creditsAllocated !== undefined)
  ) {
    return (
      <>
        {!showAdditionalBudget ? (
          <div className={styles.creditsLeftTopContainer}>
            <div className={styles.creditsLeftContainer}>
              Budget left:{' '}
              <span className={styles.creditValues}>
                {internalRecord.creditsLeft
                  ? addSpaces(creditsToEuros(internalRecord.creditsLeft))
                  : '0'}{' '}
                euros
              </span>
            </div>
          </div>
        ) : null}
        <div className={styles.creditsChangeContainer}>
          <div className={styles.creditsChangeRow}>
            Do you want to {!isEditing ? 'manually' : ''} increase or decrease
            budget?
          </div>
          <div className={styles.creditsChangeRow}>
            <div className={styles.optionContainer}>
              <input
                type="radio"
                value={creditsChangeType.INCREASE}
                name="Recommended"
                onChange={e => setCreditsChangeTypePopup(e.target.value)}
                checked={creditsChangeTypePopup === creditsChangeType.INCREASE}
              />
              Increase budget
            </div>
            <div className={styles.optionContainer}>
              <input
                type="radio"
                value={creditsChangeType.DECREASE}
                name="Strict"
                onChange={e => setCreditsChangeTypePopup(e.target.value)}
                checked={creditsChangeTypePopup === creditsChangeType.DECREASE}
              />
              Decrease budget
            </div>
          </div>
          <div className={styles.creditsChangeRow}>Amount</div>
          <input
            className={styles.creditsChangeInput}
            placeholder="0"
            value={
              creditsChangeValue
                ? addSpaces(creditsToEuros(creditsChangeValue))
                : ''
            }
            onChange={e => {
              if (e.target.value && e.target.value !== '') {
                const valueWithoutSpaces = removeNonNumeric(e.target.value);
                const newAllocatedValue = parseFloat(valueWithoutSpaces, 10);
                setCreditsChangeValue(eurosToCredits(newAllocatedValue));
              } else {
                setCreditsChangeValue(0);
              }
            }}
            onKeyDown={evt =>
              evt.key === 'ArrowDown' ||
              evt.key === 'ArrowUp' ||
              evt.key === 'e' ||
              evt.key === 'E' ||
              evt.key === '-'
                ? evt.preventDefault()
                : null
            }
            onWheel={e => e.target.blur()}
            maxLength="7"
            type="text"
            spellCheck
          />
          euros
          {showLicenceExplanationField && (
            <>
              <div>Why do you want to increase or decrease budget?</div>
              <div className={`${styles.creditsChangeRow} ${styles.infoText}`}>
                Please note, this field is visible to clients in the budget
                overview.
              </div>
              <textarea
                className={`${styles.transactionExplanationField} ${
                  styles.creditsChangeRow
                }`}
                value={transactionExplanation}
                placeholder="E.g.: quali interviews, decision expert support, ..."
                onChange={e => setTransactionExplanation(e.target.value)}
              />
            </>
          )}
          <div
            className={
              notAllowedToSaveChanges
                ? `${styles.creditsChangeSaveButton} ${styles.notActiveButton}`
                : styles.creditsChangeSaveButton
            }
            onClick={() => onCreditsChangeTypeSave()}
            role="presentation"
          >
            Save changes
          </div>
        </div>
      </>
    );
  }

  return null;
};
